import { render, staticRenderFns } from "./AvatarWithDnD.vue?vue&type=template&id=12d6dc8c&scoped=true&"
import script from "./AvatarWithDnD.vue?vue&type=script&lang=ts&"
export * from "./AvatarWithDnD.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarWithDnD.vue?vue&type=style&index=0&id=12d6dc8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d6dc8c",
  null
  
)

export default component.exports